async function isGiftCardAvailable(giftCardVariantId) {
    try {
        // Use the correct handle for your gift card product
        const response = await fetch(`/products/free-gift-card-cia2025?variant=${giftCardVariantId}`);
        // If the response is 200, the product exists and is published
        return response.ok;
    } catch (e) {
        return false;
    }
}

async function AddAutomaticGiftCard(cart) {
    // Clean up old sessionStorage for users who have it from previous version
    
    updateCartCount(cart);

    const giftCardVariantId = 52349316890996;

    // Add or remove the class on the body depending on the presence of the gift card
    if (cart.items.some(item => item.variant_id === giftCardVariantId)) {
        document.body.classList.add('gift-card-added-to-cart');
    } else {
        document.body.classList.remove('gift-card-added-to-cart');
    }

    const hasGiftCard = cart.items.some(item => item.variant_id === giftCardVariantId);
    const giftCardItem = cart.items.find(item => item.variant_id === giftCardVariantId);

    // 1. If the only item in the cart is the gift card, remove it and the banner
    if (cart.items.length === 1 && hasGiftCard) {
        removeGiftCard(cart, giftCardVariantId);
        return;
    }

    // 3. If the gift card is present
    if (hasGiftCard) {
        removeGiftCardControls(giftCardVariantId);
        // If quantity > 1, set it back to 1
        if (giftCardItem.quantity > 1) {
            setGiftCardQuantityOne(giftCardItem);
        }
    }
}

function removeGiftCardControls(giftCardVariantId) {
    // Hide the gift card controls item in the cart
    const giftCardElements = document.querySelectorAll(
        '.cart__item[data-cart-item-id^="' + giftCardVariantId + '"] .grid__item.medium-up--one-third, .ajaxcart__product[data-cart-item-id^="' + giftCardVariantId + '"] .cart_item__bottom-action'
    );
    
    giftCardElements.forEach(element => {
        if (window.location.href !== 'https://lolablankets.com/cart') {
            element.style.display = 'none';
        }else{
            element.style.visibility = 'hidden';
        }
    });
}

async function setGiftCardQuantityOne(giftCardItem) {
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: giftCardItem.key,
                quantity: 1
            })
        });
        
        if (response.ok) {
            const data = await response.json();
            // Update UI immediately
            if (typeof window.refreshCartDrawer === 'function') {
                window.refreshCartDrawer();
            }
            
            // Trigger cart update event
            $('body').trigger('updateCart', data);
            
            // Update cart count
            const cartCountElement = document.querySelector('.cart-link__count');
            if (cartCountElement) {
                cartCountElement.textContent = data.item_count;
            }
        }
    } catch (error) {
        console.error('Error setting gift card quantity:', error);
    }
}

async function removeGiftCard(cart, giftCardVariantId) {
    try {
        // Remove the gift card from the cart if it is present
        if (cart && cart.items && cart.items.length > 0) {
            if (cart.items.length === 1 && cart.items[0].variant_id === giftCardVariantId) {
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: cart.items[0].key,
                        quantity: 0
                    })
                });
                
                if (response.ok) {
                    const data = await response.json();
                    // Update UI immediately
                    if (typeof window.refreshCartDrawer === 'function') {
                        window.refreshCartDrawer();
                    }
                    
                    // Trigger cart update event
                    $('body').trigger('updateCart', data);
                    
                    // Update cart count
                    const cartCountElement = document.querySelector('.cart-link__count');
                    if (cartCountElement) {
                        cartCountElement.textContent = data.item_count;
                    }
                }
            }
        }

        if (tag_cia) {
            const itemGiftCard = cart.items.find(item => item.variant_id === giftCardVariantId);
            if (itemGiftCard) {
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: itemGiftCard.key,
                        quantity: 0
                    })
                });
                
                if (response.ok) {
                    const data = await response.json();
                    // Update UI immediately
                    if (typeof window.refreshCartDrawer === 'function') {
                        window.refreshCartDrawer();
                    }
                    
                    // Trigger cart update event
                    $('body').trigger('updateCart', data);
                    
                    // Update cart count
                    const cartCountElement = document.querySelector('.cart-link__count');
                    if (cartCountElement) {
                        cartCountElement.textContent = data.item_count;
                    }
                }
            }
        }
    } catch (error) {
        console.error('Error removing gift card:', error);
    }
}

function updateCartCount(cart) {
    const count = cart.item_count;
    document.querySelector('.cart-link__count').textContent = count;
    if (cart.item_count === 0) {
        document.body.classList.remove('cart-has-items');
        const cartDrawer = document.querySelector('.drawer__contents.cart');
        const form = document.querySelector('form.cart');
        if (form) {
            form.classList.add('cart--empty');
        }
        if (cartDrawer) {
            cartDrawer.classList.add('cart--empty');
        }
    }
}